module.exports = __webpack_public_path__ + "54590b8ef3f86965eff9c8f61f4b03ba.pdf";